import { EntityId } from '@reduxjs/toolkit';
import { ROUTER_API } from 'app/constants/api.constant';
import { ListObject } from 'app/main/design-system/models/listObjectsModel';
import BaseApi from 'app/services/api/base.api';
import { FORMS_BASE_PATH } from '../constants';
import {
  FormInDTO,
  FormOutDTO,
  FormStats,
  FormStatsFilters,
  FormTextAnswer,
  FormUpdateDTO,
  MerchantFormResponseRequest,
  MerchantFormResponseResult,
} from '../types';

export const formsApi = new BaseApi({ baseURL: ROUTER_API, tokenKey: 'token', timeout: 20000 });

export const createFormApi = async (request: FormOutDTO) => {
  const response = await formsApi.api.post<FormInDTO>(FORMS_BASE_PATH, request, {});
  return response.data;
};

export const fetchFormsApi = async (page?: number, size?: number) => {
  const response = await formsApi.api.get<ListObject<FormInDTO>>(FORMS_BASE_PATH, {
    params: { page, size },
  });
  return response.data;
};

export const fetchFormApi = async (formId: EntityId) => {
  const response = await formsApi.api.get<FormInDTO>(`${FORMS_BASE_PATH}/${formId}`);
  return response.data;
};

export const updateFormApi = async (formId: EntityId, payload: FormUpdateDTO) => {
  const response = await formsApi.api.patch<FormInDTO>(`${FORMS_BASE_PATH}/${formId}`, payload, {});
  return response.data;
};

export const deleteFormApi = async (formId: EntityId) => {
  await formsApi.api.delete(`${FORMS_BASE_PATH}/${formId}`);
  return formId;
};

export const submitMerchantFormResponseApi = async (formId: EntityId, request: MerchantFormResponseRequest) => {
  const response = await formsApi.api.post<MerchantFormResponseResult>(
    `${FORMS_BASE_PATH}/${formId}/responses`,
    request,
    {},
  );
  return response.data;
};

export const fetchFormStatsApi = async (formId: EntityId, { storeId, period }: FormStatsFilters) => {
  const response = await formsApi.api.get<FormStats>(`${FORMS_BASE_PATH}/${formId}/stats`, {
    params: { storeId, period },
  });
  return response.data;
};

export const fetchFormTextAnswersApi = async (
  formId: EntityId,
  elementId: string,
  { storeId, period }: FormStatsFilters,
  page: number,
  size: number,
) => {
  const response = await formsApi.api.get<ListObject<FormTextAnswer>>(
    `${FORMS_BASE_PATH}/${formId}/stats/elements/${elementId}/answers`,
    { params: { storeId, period, page, size } },
  );
  return response.data;
};
